<template lang="pug">
div
  .card
    .container-fluid
      .row
        .col-md-12
          .white-box
            h1.box-title.m-b-0 トップページ編集
            p.text-muted.m-b-30.font-13 SWAN Proサイトのトップページ編集画面
            .form-group
              label(for='言語').col-md-12 言語
              .col-md-12
                el-select(v-model='formdata.locale', @change='changeLocale')
                  el-option(value='ja', label='日本語')
                  el-option(value='en', label='英語')
                  el-option(value='cn', label='中国語') 
                  el-option(value='kr', label='韓国語')
            .form-group
              label.col-md-12 タイトル
              .col-md-12
                el-input(type='text', v-model='formdata.title', placeholder='画面上には表示されません（コンテンツの識別に使います）')
            .form-group
              label.col-md-12 コピーライト
              .col-md-12
                el-input(type='text', v-model='formdata.copyright')
            h3.box-title スライド一覧
            TopSlideList(editPath='/swan/top_slide/edit',:formdata='formdata')
            .form-group
              label.col-md-12 スライド追加
              .col-md-12
                el-select(v-model='slideValue')  
                  el-option(v-for='(slide,index) in slidedata',:key="index",:value="index",:label="slide.title")
            .form-group
              el-button(@click='slideAdd', type='primary') 追加
            .col-md-12
              el-button.col-md-12(type='primary', v-on:click='onPreview') プレビュー
  .card
    .col-md-12
      .white-box
        h3.box-title.m-b-0 公開設定
        p.text-muted.m-b-30.font-13
          .row
            .col-sm-12.col-xs-12
              .form-group
                label(for='公開状態') 公開状態
                .row
                  .col-md-3
                    el-select(v-model='formdata.status')
                      el-option(value='draft', label='編集中')
                      el-option(value='wait', label='承認依頼') 
                      el-option(value='open', label='公開')
                  .col-md-4
                    el-button(v-if='formdata.status === "wait"', v-on:click='onDialogAgreeList', round='') 承認依頼
                    el-button(v-if='formdata.status === "open" && formdata.waiting === true', type='warning') 公開待ち
              .form-group(v-if='formdata.agree_list.length > 0')
                label(for='承認を依頼したスタッフ') 承認を依頼したスタッフ
                el-table(:data='formdata.agree_list')
                  el-table-column(property="staff_id" label="ID" width="150")
                  el-table-column(property="department" label="部署" width="200")
                  el-table-column(property="staff_name" label="名前")
                  el-table-column(property="result_view" label="結果")
              .form-group
                label(for='登録日時') 登録日時
                el-input(v-model='formdata.created_at', :disabled='true')
              .form-group
                label(for='更新日時') 更新日時
                el-input(v-model='formdata.updated_at', :disabled='true')
              .form-group
                label(for='公開予定日時') 公開予定日時
                .row
                  .col-md-4
                    el-date-picker(type='date', value-format='yyyy-MM-dd', v-model='formdata.open_date', placeholder='YYYY-MM-DD')
                  .col-md-4
                    el-time-select(v-model='formdata.open_time', placeholder='HH:MM', :picker-options="{ start: '00:00', step: '00:10', end: '23:00'}")
              div(style='margin: 20px 0')
                el-button(v-on:click="register") 登録
              el-dialog(title="依頼リスト",:visible.sync='dialogAgreeListVisible')
                el-table(:data='formdata.staff_list', @selection-change='handleSelectionChange')
                  el-table-column(type="selection", width="55")
                  el-table-column(property="staff_id" label="staff_id" width="150")
                  el-table-column(property="department" label="department" width="200")
                  el-table-column(property="staff_name" label="staff_name")
                div(style='margin-top: 20px')
                  el-button(@click='onAgreeRequest') 依頼
                  el-button(@click='onAgreeCancel') キャンセル

</template>
<script>
import axios from 'axios'
import moment from 'moment'
import TopSlideList from './slideList'
export default {
  name: 'Top',
  data () {
    return {
      locale: 'ja',
      slidedata: {},
      slideValue: '',
      formdata: {
        entry_id: '',
        locale: '',
        title: '',
        copyright: '',
        slides: [],
        agree_list: [],
        staff_list: '',
        open_date: '',
        open_time: '',
        status: '',
        waiting: false,
        created_at: '',
        updated_at: ''
      },
      dialogAgreeListVisible: false
    }
  },
  components: {
    TopSlideList
  },
  created () {
    if (this.$route.query.id) {
      this.getTopListData(this.$route.query.id, this.$route.query.locale)
    } else {
      this.formdata.locale = 'ja'
    }
    this.getSlideListData()
  },
  methods: {
    getTopListData (id, locale) {
      return axios({
        method: 'get',
        url: '/admin/swan/top/edit?locale=' + locale + '&entry_id=' + id,
        baseURL: process.env.API_BASE_URL
      }).then((res) => {
        console.log(res.data)
        // this.formdata = res.data
        this.formdata.entry_id = res.data.entry_id
        this.formdata.locale = res.data.locale
        this.formdata.title = res.data.title
        this.formdata.slides = res.data.slides
        this.formdata.agree_list = res.data.agree_list
        if (res.data.open_at) {
          this.formdata.open_date = moment(res.data.open_at).format('YYYY-MM-DD')
          this.formdata.open_time = moment(res.data.open_at).format('HH:mm')
        }
        this.formdata.created_at = moment(res.data.created_at).format('YYYY-MM-DD HH:mm:ss')
        this.formdata.updated_at = moment(res.data.updated_at).format('YYYY-MM-DD HH:mm:ss')
        this.formdata.status = res.data.status
        this.formdata.staff_list = res.data.staff_list
      }).catch(function (error) {
        console.log(error)
      })
    },
    getSlideListData () {
      return axios({
        method: 'get',
        url: '/admin/swan/top_slide',
        baseURL: process.env.API_BASE_URL
      }).then((res) => {
        var _contents = res.data.contents
        this.slidedata = _contents
        console.log(this.slidedata)
      }).catch(function (error) {
        console.log(error)
      })
    },
    slideAdd () {
      if (this.slideValue === '') {
        return
      }
      this.formdata.slides.push({ entry_id: this.slidedata[this.slideValue].entry_id, title: this.slidedata[this.slideValue].title })
    },
    changeLocale () {
      this.getTopListData(this.formdata.locale)
    },
    register (e) {
      let inputData = JSON.stringify(this.formdata)
      console.log(inputData)
      axios({
        baseURL: process.env.API_BASE_URL,
        url: '/admin/swan/top/edit',
        method: 'post',
        data: {
          data: inputData
        }
      })
        .then((response) => {
          if (this.formdata.entry_id === '' || this.formdata.entry_id === undefined) {
            this.formdata.entry_id = response.data.entry_id
          }
          this.$message({
            type: 'success',
            message: 'completed'
          })
        })
        .catch((error) => {
          this.$message({
            type: 'info',
            message: 'no completed'
          })
          console.log(error)
        })
    },
    handleSelectionChange (val) {
      this.checkList = val
    },
    onDialogAgreeList (e) {
      this.dialogAgreeListVisible = true
    },
    onAgreeRequest (e) {
      this.formdata.agree_list = this.checkList
      this.dialogAgreeListVisible = false
    },
    onAgreeCancel (e) {
      this.dialogAgreeListVisible = false
    },
    onPreview () {
      let previewURL = process.env.TOP_PREVIEW_URL
      switch (this.formdata.locale) {
        case 'en':
          previewURL = process.env.TOP_PREVIEW_URL_EN
          break
        case 'cn':
          previewURL = process.env.TOP_PREVIEW_URL_CN
          break
        case 'kr':
          previewURL = process.env.TOP_PREVIEW_URL_KR
          break
      }
      window.open(previewURL + '?id=' + this.formdata.entry_id, '_blank')
    }
  }
}
</script>
  
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/top/edit.vue